import {connect} from 'react-redux';
import ContractGates from "./Gates";
import {bindActionCreators} from 'redux';
import {getGateList} from "../../../services/redux/ContractAssetsMapping/action";

const mapStateToProps = (state) => ({
    gateList: state.contractAssetsMapping.gateList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getGateList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractGates);
